import {observable, action} from 'mobx'
import {api} from 'helpers/Api'
import {ICrudStore} from 'Store'
import {Invoice, CashDesk, Ticket, TicketCashDesk} from './Model'

export default class {
  @observable invoices: Invoice[] = []
  @observable tickets: Ticket[] = []
  @observable cashDesks: CashDesk[] = []
  @observable invoicesLoaded: boolean = false
  @observable ticketsLoaded: boolean = false
  @observable ticketGratisLoaded: boolean = false
  @observable cashDesksLoaded: boolean = false
  @observable ticketCashDesksLoaded: boolean = false
  @observable total: number = 0
  @observable ticketCashDesk: TicketCashDesk[] = []
  @observable ticketGratis: Ticket[] = []

  readInvoices() {
    return api.get('invoice').then(this.setInvoices)
  }

  readTickets() {
    return api.get('tickets?eager=[operationLine, operationLine.businessUnit, user, stretch, lines]').then(this.setTickets)
  }

  readCashDesk() {
    return api.get('cashDesk').then(this.setCashDesk)
  }
  readTicketCashDesks() {
    return api.get('ticketCashDesks?eager=[lines]').then(this.setTicketCashDesk)
  }

  readTicketGratis() {
    return api.get('ticketGratis?eager=[operationLine, operationLine.businessUnit, user, stretch, lines]').then(this.setTicketGratis)
  }

  readTicketCanceled() {
    return api.get('ticketCanceled?eager=[operationLine, operationLine.businessUnit, user, stretch, lines]').then(this.setTicketGratis)
  }

  readTicket( id: number ) {
    return api.get(`tickets?id=${id}&eager=[operationLine, operationLine.businessUnit, user, stretch, lines]`)
  }

  @action
  setTotal (total: number) {
    // console.log('Store - total', total)
    this.total = total
  }

  @action
  private setTickets = (tickets: Ticket[]) => {
    this.tickets = tickets.map(ticket => new Ticket(ticket))
    this.invoicesLoaded = true
  }

  @action
  private setInvoices = (invoices: Invoice[]) => {
    this.invoices = invoices.map(invoice => new Invoice(invoice))
    this.invoicesLoaded = true
  }

  @action
  private setCashDesk = (cashDesks: CashDesk[]) => {
    this.cashDesks = cashDesks.map(cashDesk => new CashDesk(cashDesk))
    this.cashDesksLoaded = true
  }

  @action
  private setTicketCashDesk = (ticketCashDesks: TicketCashDesk[]) => {
    console.log('Report Store - setTicketCashDesk - ticketCashDesks: ', ticketCashDesks)
    this.ticketCashDesk = ticketCashDesks.map(ticketCashDesk => new TicketCashDesk(ticketCashDesk))
    this.ticketCashDesksLoaded = true
  }

  @action
  private setTicketGratis = (tickets: Ticket[]) => {
      this.ticketGratis = tickets.map(ticket => new Ticket(ticket))
      this.ticketGratisLoaded = true
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/Store.ts